











































import { Component, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import { Referral } from '@/api/model/referral'
import { cloneDeep, isEqual } from 'lodash'
import { CompanyAPI, ReferralAPI } from '@/api/backend-client'
import { exportExcel } from '@/helpers/referral-list/export-excel'

@Component
export default class CompanySettingsGeneral extends Vue {
    company: Company = null
    loading: boolean = false

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.company = cloneDeep<Company>(this.$currentCompany)
        this.loading = false
    }

    async save(): Promise<void> {
        try {
            this.loading = true
            this.$root.$currentCompany = await CompanyAPI.update(this.company.id, this.company)
            await this.reload()

        } finally {
            this.loading = false
        }
    }

    loadingExportReferrals: boolean = false
    exportPage: number = 1
    exportTotalPages: number = null

    async doExport(): Promise<void> {
        this.loadingExportReferrals = true
        await exportExcel(await this.loadExportData())
        this.loadingExportReferrals = false
    }

    async loadExportData(): Promise<Referral[]> {
        let data = []

        while (this.exportTotalPages === null || this.exportTotalPages >= this.exportPage) {
            const result = await ReferralAPI.getPaged({
                pagination: true,
                page: this.exportPage,
                itemsPerPage: 100, // maximum allowed items per page in API Platform
            })

            data = [].concat(...data, ...result.collection)

            this.exportPage++
            this.exportTotalPages = result.totalPages
        }

        this.exportPage = 1
        this.exportTotalPages = null

        return data
    }

    formatPercentage(percentage: number): string {
        if (percentage === null) {
            return ''
        }

        return (percentage || 0).toLocaleString('nl', { style: 'percent' })
    }

    get hasChanges(): boolean {
        return isEqual(this.$currentCompany, this.company) === false
    }
}
